import React from "react";
import PropTypes from "prop-types";
import { Field, withFormik } from "formik";
import { useTranslation } from "react-i18next";
import {
  dataModel,
  validationDataModel,
  setInitialValues,
} from "./mermaPartFilter.data.form";
import { InputDate } from "@de-prado-dev/react-component-library";

const MermaPartFilterForm = (props) => {
  const { t } = useTranslation();
  const { handleSubmit, onClean } = props;

  return (
    <div className="row no-margin">
      <div className="col-12 mb-3">
        <div className="accordion" id="workingPartFilter">
          <div className="accordion-item">
            <h2 className="accordion-header" id="flush-headingOne">
              <button
                className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#flush-collapseOne"
                aria-expanded="false"
                aria-controls="flush-collapseOne"
              >
                {t("forms.workingPart.filter")}
              </button>
            </h2>
            <div
              id="flush-collapseOne"
              className="accordion-collapse collapse"
              aria-labelledby="flush-headingOne"
              data-bs-parent="#workingPartFilter"
            >
              <div className="accordion-body">
                <form
                  className="form-horizontal"
                  onSubmit={handleSubmit}
                  autoComplete="off"
                >
                  <div className="row">
                    <div className="col-12 col-md-2 mt-2 mt-md-0">
                      <Field
                        id="dateInit"
                        labelField={t("forms.workingPart.labels.dateInit")}
                        className="form-control"
                        name="dateInit"
                        component={InputDate}
                        language="es"
                        dateFormat="dd/MM/yyyy"
                      />
                    </div>
                    <div className="col-12 col-md-2 mt-2 mt-md-0">
                      <Field
                        id="dateEnd"
                        labelField={t("forms.workingPart.labels.dateEnd")}
                        className="form-control"
                        name="dateEnd"
                        component={InputDate}
                        language="es"
                        dateFormat="dd/MM/yyyy"
                        defaultHours={23}
                        defaultMinutes={59}
                      />
                    </div>
                  </div>
                  <div className="row mt-3">
                    <div className="col-12 d-flex justify-content-end">
                      <button
                        type="submit"
                        className="btn btn-lg btn-primary me-2"
                      >
                        <i className="fas fa-search"></i>
                      </button>
                      <button
                        type="button"
                        className="btn btn-lg btn-danger"
                        onClick={() => onClean(props.resetForm)}
                        title={t("cleanFilter")}
                      >
                        <i className="fas fa-trash"></i>
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

MermaPartFilterForm.propTypes = {
  handleSubmit: PropTypes.func,
  onClean: PropTypes.func,
};

const MermaPartFilterFormF = withFormik({
  mapPropsToValues: (props) => {
    if (props.initialValues) {
      return setInitialValues(props.initialValues);
    }
    return dataModel;
  },
  validationSchema: validationDataModel,
  handleSubmit: (values, { props, resetForm }) => {
    props.onSubmit(values, resetForm);
  },
  enableReinitialize: true,
  displayName: "MermaPartFilterForm",
})(MermaPartFilterForm);

export default MermaPartFilterFormF;
